<template>
  <div class="project-biz-log">
    <card title="项目更新动态">
      <div class="biz-log-list">
        <div class="biz-log-item" v-for="(item, key) in list" :key="key">
          <div class="text-block">{{item.create_time}}</div>
          <div class="text-block gray">{{item.project_name}}</div>
          <div class="text-block">{{item.privatename}}</div>
          <div class="text-block blue">{{item.issue_name}}</div>
          <div class="text-block">{{item.remark}}
            <template v-if="item.field_desc">：</template>
          </div>
          <div class="text-block" v-if="item.field_desc">{{item.field_desc}}</div>
          <template v-if="item.old_value">
            <div class="text-block red">{{item.old_value}}</div>
            <div class="right-block">
              <i style="transform: rotate(-90deg); display: block" class="iconfont icon-xiangxia"></i>
            </div>
          </template>
          <div class="text-block green" v-if="item.new_value">{{item.new_value}}</div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {fetch} from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      lastRequestTime: null
    }
  },
  created() {
    this.getList()
    setInterval(() => {
      this.getList(true)
    }, 1000 * 3 * 60)
  },
  methods: {
    getList(unshift = false) {
      const token = localStorage.getItem('token')
      if (!token) return;
      let endTime = dayjs().format("YYYY/MM/DD HH:mm:ss")
      fetch("post", "/bizlog/notice", {
        start_time: this.lastRequestTime,
        end_time: endTime
      }).then(res => {
        if (res.status === 0) {
          // 如果unshift是false就请求所有数据并覆盖
          // 如果unshift是true就追加数据到list前
          if (unshift) {
            this.list.unshift(...res.data)
          } else {
            this.list = res.data
          }
          this.lastRequestTime = endTime
        }
      })
    },
    open() {
      this.visible = true
    }
  }
}
</script>

<style lang="less" scoped>
.project-biz-log {
  padding: 10px;
  height: 100vh;
  .edp-card {
    height: 100%;
    /deep/ .edp-card-body {
      overflow-y: auto;
    }
    .biz-log-list {
      overflow-y: auto;
      .biz-log-item {
        padding: 0 20px;
        display: flex;
        height: 45px;
        align-items: center;
        border-bottom: 1px solid #EDEDED;;

        &:nth-child(2n) {
          background-color: #F8F8F8;
        }

        .ant-checkbox-wrapper {
          pointer-events: none;
          margin-right: 8px;
        }

        .right-block {
          margin-right: 10px; font-weight: 700; font-size: 14px; color: #909090
        }

        .text-block {
          margin-right: 10px;
          font-weight: 500;
          font-size: 14px;
          color: #303030;
          height: 25px;

          &.xk {
            max-width: 170px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }

          &.gray, &.blue, &.red, &.green, &.yellow {
            padding: 2px 5px;
            border-radius: 4px;
          }

          &.gray {
            background-color: #EEE;
          }

          &.green {
            background-color: #E9F7F2;
            color: #24B47E;
          }

          &.blue {
            background-color: #E0EEF7;
            color: #38A3FF;
          }

          &.yellow {
            background-color: #FAF4D9;
            color: #FFC600;
          }

          &.red {
            background-color: #FDE6E6;
            color: #EA0D0D;
            text-decoration: line-through;
          }
        }

        .icon {
          margin-right: 8px;
          height: 20px;
        }

        .status {
          margin-left: auto;
          height: 25px;
          line-height: 23px;
          border-radius: 20px;
          border: 1px solid #eee;
          font-size: 12px;
          padding: 0 15px;

          &.blue {
            border-color: var(--primary-color);
            color: var(--primary-color);
          }
        }
      }
    }
  }
}
</style>